<template>
  <el-dialog title="费用明细" :visible="visible" width="395px" :before-close="handleClose">
    <div class="discount-info-wrap">
      <div class="discount-info">
        <div class="left">房费</div>
        <div class="right">¥{{ discountData.marketPrice }}</div>
      </div>
      <div class="discount-info">
        <div class="left">优惠</div>
        <div class="right yellow">-¥{{ discountData.discount }}</div>
      </div>
      <div class="discount-info">
        <div class="left-wrap">
          <div class="bird">早鸟优惠</div>
          <div class="bird-info">提前{{ discountData.hitPolicy ? discountData.hitPolicy.days : 0 }}天预定享受{{ discountData.hitPolicy ? discountData.hitPolicy.discount : 0 }}折优惠</div>
        </div>
        <div class="bird-info">-¥{{ discountData.discount }}</div>
      </div>
    </div>
    <div slot="footer">
      <div class="discount-btn-wrap">
        <el-button class="discount-btn" type="primary" @click="handleClose">关闭 Close</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    discountData: {
      type: Object,
      default: {}
    }
  },
  components: {},
  data() {
    return {
    };
  },
  computed: {},
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    },
  }
};
</script>

<style lang="scss" scoped>
.discount-info-wrap {
  padding: 0 10px;
}
.discount-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
}
.discount-info .left {
  font-size: 13px;
  font-weight: 500;
  color: #3D3935;
  line-height: 36rpx;
}
.discount-info .right {
  font-size: 13px;
  font-weight: 500;
  color: #3D3935;
  line-height: 36rpx;
}
.discount-info .right.yellow {
  color: #A78E61;
}
.discount-info .left-wrap {
  display: flex;
  align-items: center;
}
.discount-info .bird {
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;
  color: #E47C47;
  background: #FFF8F2;
  line-height: 17px;
  margin-right: 10px;
}
.discount-info .bird-info {
  font-size: 12px;
  color: #999;
  line-height: 17px;
}
.discount-btn-wrap {
  margin-top: -10px;
  text-align: center;
  .discount-btn {
    border-radius: 20px;
    margin-bottom: 10px;
  }
}
</style>
